import { render, staticRenderFns } from "./ModalDeleteClient.vue?vue&type=template&id=72d1adce&"
import script from "./ModalDeleteClient.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports